<p>volt-detail-template works!</p>
